import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Shown when a request fails, in place of a loading skeleton.
 *
 * The codebase has 41 templates with a loading state and none with an error
 * state, while service-layer catchError handlers re-throw into components that
 * have nowhere to render the result. The visible consequence is that a failed
 * fetch leaves its skeleton on screen permanently - the user is given no
 * explanation and no way out.
 *
 * Deliberately small and dependency-free so it can sit anywhere a skeleton
 * currently does.
 */
@Component({
  selector: 'raksme-error',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.css']
})
export class ErrorStateComponent {

  /** Falls back to a generic message so a caller can never render it empty. */
  @Input() message: string;

  /** Retry is opt-in: only show the control when the caller can actually retry. */
  @Input() showRetry: boolean = false;

  @Input() retryLabel: string;

  @Output() retry = new EventEmitter<void>();

  get text(): string {
    return (this.message && this.message.trim())
      ? this.message
      : 'This content could not be loaded.';
  }

  get retryText(): string {
    return (this.retryLabel && this.retryLabel.trim()) ? this.retryLabel : 'Try again';
  }

  onRetry(): void {
    this.retry.emit();
  }
}
